import React, {Component} from 'react';
import {Navigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {
  FlashState,
  withAuthentication,
  withRouter
} from "cw-styleguide-react";
import ContactsEditView from "../views/ContactsEditView";
import ContactsCreateView from "../views/ContactsCreateView";
import {LANGUAGE_EN, OPERATION_EDIT} from "../../../constants";
import NavigateWithSearch from '../../../components/NavigateWithSearch';

class ContactsCreateEditController extends Component {

  /**
   * constructor.
   * @param props
   */
  constructor(props) {
    super(props);

    // Set the initial state..
    this.state = {
      language: LANGUAGE_EN,
      success: false,
      failure: false,
      submitting: false
    }

  }

  /**
   * componentDidMount.
   */
  componentDidMount() {
    // If we are editing a contact then load it into the state.
    if (this.props.operation === OPERATION_EDIT) {
      this.props.loadContact(this.props.params.contact)
      this.props.loadAudit(this.props.params.contact);
    } else {
      this.props.clearAudit();
      this.props.clearContact()
    }

    this.props.clearMessages();
  }





  /**
   * render.
   * @returns {JSX.Element}
   */
  render() {

    if (this.props.redirect) {
      FlashState.set('flashMessages', this.props.messages);
      return <NavigateWithSearch path={this.props.redirect } />
    }

    // Return the view based on if we are editing or creating a venue.
    if (this.props.operation === OPERATION_EDIT) {
      return <ContactsEditView {...this.props} {...this.state} />;
    } else {

      return <ContactsCreateView {...this.props} {...this.state}  />;
    }

  }
}

export default withRouter(withAuthentication(withTranslation('local')(ContactsCreateEditController)));
